import { useState } from 'react'

export default function YouTubeFacade({
  videoId = 'cU16yYjhU9E',
  title = 'CasperDJ Balletskole',
  poster = 'https://i.ytimg.com/vi/cU16yYjhU9E/hqdefault.jpg'
}) {
  const [isPlaying, setIsPlaying] = useState(false)

  return (
    <div className="relative w-full aspect-video rounded-2xl overflow-hidden border border-neutral-800 bg-neutral-900 shadow-2xl">
      {isPlaying ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full border-0"
        />
      ) : (
        <div
          className="relative w-full h-full cursor-pointer group"
          onClick={() => setIsPlaying(true)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              setIsPlaying(true)
            }
          }}
          aria-label={`Afspil video: ${title}`}
        >
          <img
            src={poster}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors flex items-center justify-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gold-400 text-black flex items-center justify-center shadow-2xl transition-transform duration-300 group-hover:scale-110">
              <i className="fa-solid fa-play text-xl sm:text-2xl ml-1" aria-hidden="true" />
            </div>
          </div>
          <div className="absolute bottom-4 left-4 right-4 bg-neutral-950/80 backdrop-blur-md px-4 py-2.5 rounded-xl border border-neutral-800/80 text-white text-sm flex items-center justify-between">
            <span className="font-semibold truncate">{title}</span>
            <span className="text-xs text-gold-400 shrink-0 ml-2 font-medium">Klik for at se video</span>
          </div>
        </div>
      )}
    </div>
  )
}
